<section class="conversations-container">
  <button type="button" (click)="onBackClick()" mat-icon-button class="back-button">
    <div class="flex align-center gap-2">
      <fa-icon [icon]="['far', 'arrow-left']"></fa-icon>
      <span>Back</span>
    </div>
  </button>
  <!--
    V-6. Say what happens to this history.

    A nightly job archives and DELETES any conversation untouched for 90 days,
    and there is no restore. Nothing anywhere in the product said so, so the
    first a member knew was a conversation that was no longer there.

    Stated rather than warned-before-purge on purpose: a per-conversation
    countdown needs the archive date on the wire and a new surface to render it,
    and the finding allows either. This is the half that is true for every
    member the day it ships.

    Above the list, not below it: the list lazy-loads, so a foot note is one a
    member with a long history never reaches.
  -->
  <p class="retention-note">
    Conversations you have not opened for 90 days are removed, and cannot be
    brought back.
  </p>
  <div
    class="conversation-list"
    cpdLazyLoadingList
    [disabled]="conversationsLoading"
    [limit]="conversationsLimit"
    [offset]="conversationsOffset"
    [count]="conversationsCount"
    (next)="onNext($event)"
  >
    @for (conversation of conversations; track conversation.id) {
      <cpd-conversation-card
        [expanded]="expanded"
        [conversation]="conversation"
        (click)="onConversationSelect(conversation.id)"
        (deleteConversation)="onDeleteConversation($event)"
      ></cpd-conversation-card>
    } @empty {
      <div class="no-results">No conversations found</div>
    }

    @if (conversationsLoading) {
      @for (item of [].constructor(3); track $index) {
        <cpd-conversation-skeleton></cpd-conversation-skeleton>
      }
    }
  </div>
</section>
